var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 43,
    viewBox: "0 0 53 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6006 27.8461L4.4 32L5.51049 24.125C2.7107 21.6689 1 18.3853 1 14.7778C1 7.16852 8.61116 1 18 1C27.3888 1 35 7.16852 35 14.7778C35 22.387 27.3888 28.5556 18 28.5556C16.1126 28.5556 14.297 28.3063 12.6006 27.8461Z",
    stroke: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6006 37.8461L21.4 42L22.5105 34.125C19.7107 31.6689 18 28.3853 18 24.7778C18 17.1685 25.6112 11 35 11C44.3888 11 52 17.1685 52 24.7778C52 32.387 44.3888 38.5556 35 38.5556C33.1126 38.5556 31.297 38.3063 29.6006 37.8461Z",
    fill: "#F5F6FA",
    stroke: "#373737"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInformation);
export default __webpack_public_path__ + "static/media/contact-information.9b14dabb.svg";
export { ForwardRef as ReactComponent };